import { render, staticRenderFns } from "./ReceivablePage.vue?vue&type=template&id=c6cdf666&scoped=true"
import script from "./ReceivablePage.vue?vue&type=script&lang=js"
export * from "./ReceivablePage.vue?vue&type=script&lang=js"
import style0 from "./ReceivablePage.vue?vue&type=style&index=0&id=c6cdf666&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cdf666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6cdf666')) {
      api.createRecord('c6cdf666', component.options)
    } else {
      api.reload('c6cdf666', component.options)
    }
    module.hot.accept("./ReceivablePage.vue?vue&type=template&id=c6cdf666&scoped=true", function () {
      api.rerender('c6cdf666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/feeInfoTab/components/ReceivablePage.vue"
export default component.exports